import React from 'react';
import ReactDOM from 'react-dom';

import { CircularProgress } from '@mui/material';

interface ProgressBarProps {
  fullscreen?: boolean;      // standaard true
  invert?: boolean;          // standaard true
  spinner?: boolean;         // standaard true
  text?: string;             // standaard "Een moment geduld a.u.b."
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  fullscreen = true,
  invert = true,
  spinner = true,
  text = 'Een moment geduld a.u.b.'
}) => {

  const classNames = [
    'progress-bar',
    fullscreen ? 'fullscreen-active' : '',
    invert ? 'invert-active' : '',
    spinner ? 'spinner-active' : ''
  ].join(' ').trim();

  return ReactDOM.createPortal(
    <div className={classNames}>
      <div className="progress-bar-inner"></div>
      <span>
        <CircularProgress className="spinner" color="inherit" size="40px" />
        {text}
      </span>
    </div>,
    document.body
  );
};

export default ProgressBar;
